import { useTranslate } from "ra-core";

import { usePilotReportsNewCount } from "./usePilotReportsNewCount";

/** Almikia Epic PL (TASK-062): count of `nuevo` reports next to the Settings entry; hidden at zero. */
export const PilotReportsBadge = () => {
  const translate = useTranslate();
  const count = usePilotReportsNewCount();
  if (count === 0) return null;
  return (
    <span
      data-testid="pilot-reports-badge"
      aria-label={translate("crm.pilotReports.new_badge", {
        smart_count: count,
      })}
      className="ml-2 inline-flex min-w-5 items-center justify-center rounded-full bg-primary px-1.5 text-xs font-medium text-primary-foreground tabular-nums"
    >
      {count}
    </span>
  );
};
